// @flow

import React from 'react';
import BrandLogo from 'client/components/brandLogo';

type Props = {
  brandName?: string,
  // logoUrl: string,
};

// const Hero = ({ brandName, logoUrl }: Props) => (
const Hero = ({ brandName }: Props) => (
  <div className="hero flex-row">
    <div className="center-col-small flex-column">
      <BrandLogo assetBase="/assets" brandName={brandName} />
      {/* <BrandLogo assetBase="/assets" brandName={brandName} logoUrl={logoUrl} /> */}
    </div>
  </div>
);

Hero.defaultProps = {
  brandName: 'stride',
};

export default Hero;
